import { Grid } from '@material-ui/core';

import { ChannelSelector } from '@/components/modules/Users/components/ChannelSelector';
import { ChannelUsers } from '@/components/modules/Users/components/ChannelUsers';
import { useChannelSelector } from '@/components/modules/Users/hooks/useChannelSelector';
import { ModuleCorePermissionProps } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

interface UsersProp extends ModuleCorePermissionProps {}

const Users = ({ canEdit = false }: UsersProp) => {
  const { allChannels, selectedChannel, setSelectedChannel, isUserMerchant } = useChannelSelector();

  return (
    <Grid container spacing={6}>
      {isUserMerchant && (
        <Grid item xs={12} sm={3}>
          <ChannelSelector
            canEdit={canEdit}
            setSelectedChannel={setSelectedChannel}
            selectedChannel={selectedChannel}
            allChannels={allChannels}
            isUserMerchant={isUserMerchant}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={isUserMerchant ? 9 : 12}>
        <ChannelUsers canEdit={canEdit} selectedChannel={selectedChannel} />
      </Grid>
    </Grid>
  );
};

export const UsersModule = withPermissionsModule(Users);
